
<div>
	<div v-if="blackout && open" class="slideup-blackout" :position="position" />
	<transition name="slideup-transition" appear>
		<div
			v-if="open"
			class="flow-slideup-container"
			:position="position"
			:state="state"
			:border="border"
		>
			<div v-if="$slots['header']" class="flow-slideup-header">
				<!-- @slot Used to display header or icons -->
				<slot name="header" />
			</div>
			<div class="flow-slideup-body">
				<!-- @slot Used to display content of slideup such as messages or user input -->
				<slot />
			</div>
			<div v-if="$slots['footer']" class="flow-slideup-footer">
				<!-- @slot Used to display actions that is buttons or links -->
				<slot name="footer" />
			</div>
		</div>
	</transition>
</div>
